import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi, formatApiError } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { useCountry } from '../contexts/CountryContext';

export default function ChangePassword() {
  const navigate = useNavigate();
  const { user, refreshProfile } = useAuth();
  const { country } = useCountry();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e?.preventDefault();
    setError('');
    if (next.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères.');
      return;
    }
    if (next !== confirm) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }
    setBusy(true);
    try {
      await authApi.changePassword(current, next);
      await refreshProfile();
      const role = user?.role;
      if (role === 'superadmin') navigate('/', { replace: true });
      else if (role === 'admin_region' || role === 'admin_commune') navigate('/dashboard-admin', { replace: true });
      else if (role === 'agent') navigate('/agent', { replace: true });
      else navigate('/carte', { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-5"
      style={{ background: country.palette.primary }}
      data-testid="change-password-page"
    >
      <form
        onSubmit={submit}
        className="bg-white rounded-2xl shadow-2xl w-full max-w-[420px] p-7 space-y-4"
      >
        <div>
          <div className="text-xl font-bold mb-1">🔐 Changement de mot de passe</div>
          <p className="text-xs text-gray-500">
            Votre mot de passe est temporaire. Choisissez-en un nouveau pour activer votre compte.
          </p>
        </div>
        {error && (
          <div className="bg-red-50 text-red-700 rounded-lg px-3 py-2 text-sm" data-testid="cp-error">
            {error}
          </div>
        )}
        <div>
          <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
            Mot de passe actuel (temporaire)
          </label>
          <input
            type="password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            required
            className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 text-sm outline-none focus:border-blue-600"
            data-testid="cp-current"
          />
        </div>
        <div>
          <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
            Nouveau mot de passe
          </label>
          <input
            type="password"
            value={next}
            onChange={(e) => setNext(e.target.value)}
            required
            minLength={8}
            className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 text-sm outline-none focus:border-blue-600"
            data-testid="cp-new"
          />
        </div>
        <div>
          <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
            Confirmer
          </label>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 text-sm outline-none focus:border-blue-600"
            data-testid="cp-confirm"
          />
        </div>
        <button
          type="submit"
          disabled={busy}
          className="w-full py-3.5 rounded-xl text-white font-bold text-sm disabled:opacity-50"
          style={{ background: country.palette.primary }}
          data-testid="cp-submit"
        >
          {busy ? '…' : 'Définir mon mot de passe'}
        </button>
      </form>
    </div>
  );
}
